/** @format */

export const countries = (t) => [
  {
    countryId:"63556b49614a6ddc9ceeb61e", // production
    code: "KZ",
    name: t("countries.kazakhstan"),
    dialCode: "+7",
    flag: "🇰🇿",
    mask: "+7 (999) 999-99-99",
    placeholder: "+7 (___) ___-__-__",
  },
  {
    countryId:"63556bc1614a6ddc9ceeb61f", // production
    code: "RU",
    name: t("countries.russia"),
    dialCode: "+7",
    flag: "🇷🇺",
    mask: "+7 (999) 999-99-99",
    placeholder: "+7 (___) ___-__-__",
  },
  {
    countryId:"675291b7cb13e2ce5b664518", // production
    code: "CN",
    name: t("countries.china"),
    dialCode: "+86",
    flag: "🇨🇳",
    mask: "+86 999 9999 9999",
    placeholder: "+86 ___ ____ ____",
  },
  {
    countryId:"680a096ea12fc0b64ab9aef7", // production
    code: "US",
    name: t("countries.usa"),
    dialCode: "+1",
    flag: "🇺🇸",
    mask: "+1 (999) 999-9999",
    placeholder: "+1 (___) ___-____",
  },
  {
    countryId:"680a096ea12fc0b64ab9aef0", // production
    code: "DE",
    name: t("countries.germany"),
    dialCode: "+49",
    flag: "🇩🇪",
    mask: "+49 999 99999999",
    placeholder: "+49 ___ ________",
  },
  {
    countryId:"680a096ea12fc0b64ab9aef5", // production
    code: "GB",
    name: t("countries.unitedKingdom"),
    dialCode: "+44",
    flag: "🇬🇧",
    mask: "+44 9999 999999",
    placeholder: "+44 ____ ______",
  },
  {
    countryId:"65c4ac74cf2803d580f5c2db", // production
    code: "TR",
    name: t("countries.turkey"),
    dialCode: "+90",
    flag: "🇹🇷",
    mask: "+90 999 999 99 99",
    placeholder: "+90 ___ ___ __ __",
  },
  {
    countryId:null, // production (нет в списке)
    code: "UA",
    name: t("countries.ukraine"),
    dialCode: "+380",
    flag: "🇺🇦",
    mask: "+380 99 999 99 99",
    placeholder: "+380 __ ___ __ __",
  },
  {
    countryId:"648b0836d64a46fc66c74273", // production
    code: "UZ",
    name: t("countries.uzbekistan"),
    dialCode: "+998",
    flag: "🇺🇿",
    mask: "+998 99 999 99 99",
    placeholder: "+998 __ ___ __ __",
  },
  {
    countryId:"6571605d90729eb27c0597d9", // production
    code: "KG",
    name: t("countries.kyrgyzstan"),
    dialCode: "+996",
    flag: "🇰🇬",
    mask: "+996 999 999 999",
    placeholder: "+996 ___ ___ ___",
  },
  {
    countryId:"6a26907c686bd35d2726b681", // production
    code: "GE",
    name: t("countries.georgia"),
    dialCode: "+995",
    flag: "🇬🇪",
    mask: "+995 999 999 999",
    placeholder: "+995 ___ ___ ___",
  },
  {
    countryId: null,
    code: "CH",
    name: t("countries.switzerland"),
    dialCode: "+41",
    flag: "🇨🇭",
    mask: "+41 99 999 99 99",
    placeholder: "+41 __ ___ __ __",
  },
  {
    countryId: null,
    code: "AE",
    name: t("countries.unitedArabEmirates"),
    dialCode: "+971",
    flag: "🇦🇪",
    mask: "+\\971 99 999 9999",
    placeholder: "+971 __ ___ ____",
  },
  {
    countryId: null,
    code: "RS",
    name: t("countries.serbia"),
    dialCode: "+381",
    flag: "🇷🇸",
    mask: "+381 99 999 9999",
    placeholder: "+381 __ ___ ____",
  },
];

export const getCountryByCode = (code, t) => {
  const countriesList = countries(t);
  return countriesList.find((country) => country.code === code) || countriesList[0];
};

export const getCountryById = (id, t) => {
  if (!id) return null;
  return countries(t).find((country) => country.countryId === id) || null;
};

export const getCountryByDialCode = (dialCode, t) => {
  const countriesList = countries(t);
  return countriesList.find((country) => country.dialCode === dialCode) || countriesList[0];
};

export const detectUserCountry = () => {
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const browserLanguage = navigator.language || navigator.userLanguage;

    if (timezone) {
      const timezoneToCountryMap = {
        "Asia/Almaty": "KZ",
        "Asia/Qyzylorda": "KZ",
        "Asia/Aqtobe": "KZ",
        "Asia/Aqtau": "KZ",
        "Asia/Oral": "KZ",
        "Europe/Moscow": "RU",
        "Asia/Yekaterinburg": "RU",
        "Asia/Novosibirsk": "RU",
        "Asia/Shanghai": "CN",
        "Asia/Urumqi": "CN",
        "America/New_York": "US",
        "America/Chicago": "US",
        "America/Los_Angeles": "US",
        "Europe/Berlin": "DE",
        "Europe/London": "GB",
        "Europe/Istanbul": "TR",
        "Europe/Kiev": "UA",
        "Asia/Tashkent": "UZ",
        "Asia/Bishkek": "KG",
      };

      if (timezoneToCountryMap[timezone]) {
        return timezoneToCountryMap[timezone];
      }
    }

    if (browserLanguage) {
      const countryFromLocale = browserLanguage.split("-")[1]?.toUpperCase();

      if (countryFromLocale && countries.find((c) => c.code === countryFromLocale)) {
        return countryFromLocale;
      }

      const langCode = browserLanguage.split("-")[0].toLowerCase();
      const languageToCountryMap = {
        ru: "RU",
        kk: "KZ",
        zh: "CN",
        en: "US",
        de: "DE",
        tr: "TR",
        uk: "UA",
        uz: "UZ",
        ky: "KG",
      };

      if (languageToCountryMap[langCode]) {
        return languageToCountryMap[langCode];
      }
    }
  } catch (error) {
    console.warn("Не удалось определить страну пользователя:", error);
  }

  return "KZ";
};
